import Vue from 'vue'
import Router from '@/router'
import { getStore } from '/utils/storage'
import Axios from 'axios'
import qs from 'qs'

let baseUrl = 'https://b.kukahome.com/'
if (process.env.NODE_ENV !== 'development') {
  baseUrl = process.env.BASE_API.indexOf('http') !== -1 ? process.env.BASE_API : window.location.origin
}
let axios = Axios.create({
  baseURL: baseUrl,
  data: {},
  headers: { 'Content-Type': 'application/json' }
})

// axios.defaults.timeout = 10000
// 不需要跳转登录的白名单
const whiteList = [
	{url: `${baseUrl}api/h5app/wxapp/member/collect/item`, method: 'get'},
	{url: `${baseUrl}api/h5app/wxapp/member`, method: 'get'},
	{url: `${baseUrl}api/h5app/wxapp/cart`, method: 'get'},
  {url: `${baseUrl}api/h5app/wxapp/cartcount`, method: 'get'},

  {url: `${baseUrl}api/h5app/wxapp/goods/items`, method: 'get'},
  {url: `${baseUrl}api/h5app/wxapp/member/collect/distribution`, method: 'get'},
  {url: `${baseUrl}api/h5app/wxapp/member/collect/item`, method: 'get'},
  {url: `${baseUrl}api/h5app/wxapp/cartcount`, method: 'get'},
]

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  switch (error.response.status) {
    case 401:
      let flag = false
      whiteList.map(v => {
        const {url, method} = error.response.config
        v.url === url && v.method === method && (flag = true)
      })
      if (flag) { console.log('axios.interceptor白名单 url---> ', error.response.config.url); break }
      console.log('continue', error.response.config)
      Router.push({path: '/login'})
      break
    default:
      console.log('操作失败', error.response)
      Vue.prototype.$message.error({
        message: error.response.data.error ? error.response.data.error.message : '操作失败! 请稍后重试!'
      })
      break
  }
  return Promise.reject(error)
})
const fetch = function (url = '', data = {}, type = 'GET', token = false, special) {
  let params = {
    url: url,
    data: data,
    method: type,
    headers: {}
  }

  if (token) {
    params.headers['Authorization'] = `Bearer ${getStore('token')}`
  }

  if (type === 'GET') {
    params.params = Object.assign({}, data, {company_id: '2'})
    // params.params = Object.assign({}, data, {})
  }
  // params.data = Object.assign({}, params.data, {})
  params.data = Object.assign({}, params.data, {company_id: '2'})

  if (type === 'DELETE' && special === 'special') { // 取消收藏
    params.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    params.data = qs.stringify(params.data)
  }
  // console.log('request params', params)
  return new Promise((resolve, reject) => {
    axios(params).then(res => {
    // axios.request(params).then(res => {
      resolve(res.data)
    }).catch(error => {
      reject(error)
    })
  })
}
console.warn('baseUrl',baseUrl)
export default { fetch, baseUrl }



// WEBPACK FOOTER //
// ./src/api/public.js